import script from "./PasswordPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordPanel.vue?vue&type=script&setup=true&lang=js"

import "./PasswordPanel.vue?vue&type=style&index=0&id=3ea5a1ce&lang=scss"

const __exports__ = script;

export default __exports__